export default __webpack_public_path__ + "static/media/opisane_proc.526dd808.pdf";